module.exports = __webpack_public_path__ + "static/img/bg_card.289e3b8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bfSaled-2025/bg_card.gif
// module id = fZjLR
// module chunks = 1